<template>
  <div class="login-container">
    <div class="login-weaper animated bounceInDown">
      <div class="login-border">
        <div class="left-bottom-sign" />
        <div class="right-top-sign" />
        <div class="login-main">
          <h4 class="login-title">
            量子智慧车库
          </h4>
          <div id="form_wrapper">
            <div class="login_form">
              <Form ref="form" :model="formFields" :rules="ruleValidate">
                <div class="form-item">
                  <FormItem prop="username">
                    <i-input
                      v-model="formFields.username"
                      prefix="ios-contact"
                      placeholder="请输入用户名..."
                      class="input-noborder"
                      @keyup.enter.native="handleLogin"
                    />
                  </FormItem>
                </div>
                <div class="form-item">
                  <FormItem prop="password">
                    <i-input
                      v-model="formFields.password"
                      type="password"
                      password
                      prefix="ios-lock"
                      placeholder="请输入密码..."
                      class="input-noborder"
                      @keyup.enter.native="handleLogin"
                    />
                  </FormItem>
                </div>
              </Form>
              <div class="form-item form-buttons">
                <Button type="primary" :loading="submitStatus" long @click="handleLogin()">
                  登录
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer link -->
    <footer class="login-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号：</a>
      <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备20002049号</a>
    </footer>
  </div>
</template>

<script>
const qs = require('qs')
import request from '@/utils/request'
import { mapMutations } from 'vuex'
import { dateFormat } from '@/utils/util'
export default {
  name: 'Userlogin',
  props: [],
  data() {
    return {
      submitStatus: false,
      time: '',
      formFields: { username: '', password: '' },
      ruleValidate: {
        username: [{ required: true, message: '用户名不能为空!', trigger: 'blur' }],
        password: [
          { required: true, message: '用户密码不能为空!', trigger: 'blur' },
          { min: 4, message: '密码长度最少为4位', trigger: 'blur' }
        ]
      },
      passwordType: 'password'
    }
  },
  computed: {
    screenHeight() {
      return document.body.clientWidth - 100
    }
  },
  created() {
    this.getTime()
    setInterval(() => {
      this.getTime()
    }, 1000)
  },
  mounted() {
    if (this.$store.state.app.accessToken) {
      this.$router.replace('Home')
    }
  },
  methods: {
    ...mapMutations([
      'setToken'
    ]),
    getTime() {
      this.time = dateFormat(new Date())
    },
    showPassword() {
      this.passwordType === ''
        ? (this.passwordType = 'password')
        : (this.passwordType = '')
    },
    handleLogin() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitStatus = true
          var formData = new FormData()
          const self = this
          Object.keys(this.formFields).forEach(function(key) {
            const fieldValue = self.formFields[key]
            if (fieldValue instanceof Array && fieldValue.length === 0) {
              return
            }
            (fieldValue || fieldValue === 0) && formData.append(key, fieldValue)
          })
          request({
            url: '/oauth/form/token',
            method: 'POST',
            data: qs.stringify(this.formFields),
            headers: { 'Content-type': 'application/x-www-form-urlencoded;charset=utf-8' }
          }).then(res => {
            this.submitStatus = false
            this.setToken(res.data)
            this.$router.replace('Home')
          }).catch(error => {
            this.submitStatus = false
            console.log(error)
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.form-item {
    margin-top: 30px !important;
}

.right-top-sign{
	position:absolute;
	top: 10px;
	right: -30px;
	z-index: 95;
	&:before, &:after{
		display:block;
		content:"";
		width: 350px;
		height: 20px;
		background: #52cccc; //#2fa585; //#b4f3e2;
	}
	&:before{
		transform: rotate(50deg);
		border-radius: 0 50px 0 0;
	}
	&:after{
		position: absolute;
		right: -198px;
		top: 0;
		transform: rotate(-50deg);
		border-radius: 50px 0 0 0;
		/* background: pink; */
	}
}

.left-bottom-sign{
	position:absolute;
	left: -270px;
	bottom: -320px;
	border: 50px solid #d0d1fd;
	border-radius: 50%;
	padding: 180px;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  height: 100px;
  font-family: Roboto;
  font-size: 100px;
  line-height: 100px;
  font-weight: bold;
  color: rgba(137, 165, 193, 0.08);
  text-shadow: 0 2px 4px rgba(207, 217, 223, 0.1);
}
.login-footer {
  position: fixed;
  bottom: 10px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #999;
}
</style>
